import { ReactNode } from 'react';

export interface SidebarContextType {
  isCollapsed: boolean;
  sidebarWidth: number;
  toggleSidebar: () => void;
  setSidebarCollapsed: (collapsed: boolean) => void;
  isXlBreakpoint: boolean;
}

export const defaultContext: SidebarContextType = {
  isCollapsed: false,
  sidebarWidth: 240,
  toggleSidebar: () => {},
  setSidebarCollapsed: () => {},
  isXlBreakpoint: false,
};

export interface SidebarProviderProps {
  children: ReactNode;
}

// Constants for sidebar widths
export const SIDEBAR_COLLAPSED_WIDTH = 72;
export const SIDEBAR_EXPANDED_WIDTH_DEFAULT = 240;
export const SIDEBAR_EXPANDED_WIDTH_XL = 260;

// XL breakpoint in pixels (typically 1280px)
export const XL_BREAKPOINT = 1520;
